<div class="timezone-selector" [class.compact]="compact()">
	<div class="timezone-display">
		@if (shouldShowDropdown() && timezonesLoaded()) {
			<md-drop-down
				[searchable]="true"
				[options]="timezoneOptions()"
				[value]="timezoneContext().selectedTimezone?.timeZoneID"
				(change)="onTimezoneSelect($event)"
				class="timezone-dropdown"
			>
				<div class="timezone-trigger">
					<span class="timezone-text">{{ selectedTimezoneAbbrev() }}</span>
				</div>
			</md-drop-down>
		} @else if (shouldShowDropdown() && !timezonesLoaded()) {
			<div class="timezone-loading">
				<span class="timezone-text">Loading...</span>
			</div>
		}
	</div>
</div>
